import { Layout, Row, Col } from "antd";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
